// import { get_headers } from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
// import axios from "axios";

export default {
  name: "facial_biometric",
  mixins: [alert_mixin],
  props: {
    model_value: { type: [Object, String], default: () => ({}) },
    question: { type: Object, default: () => ({}) },
  },
  emits: ["update:model_value"],
  data: () => ({
    step: "instructions", // controls which section to show
    user_profile_data: { id_number: "", user_id: "" },
    photo_taken: false,
    photo_src: "",
    video_element: null,
    canvas_element: null,
    stream: null,
    csrf_token: "",
    camera_loading: false,
    camera_error: null,
  }),
  mounted() {
    this.$nextTick(() => {
      this.load_user_data();
      this.csrf_token = this.get_csrf_token();
    });
  },
  beforeUnmount() {
    this.stop_camera();
  },
  methods: {
    go_to_camera() {
      this.step = "camera";
      this.camera_loading = true;
      this.$nextTick(() => this.init_camera());
    },
    validate_camera_elements() {
      return !!(this.video_element && this.canvas_element);
    },
    setup_camera_elements() {
      this.video_element = this.$refs.video;
      this.canvas_element = this.$refs.canvas;
    },
    is_secure_context() {
      const allowed_domains = ["localhost", "127.0.0.1", "0.0.0.0", "dev.","development.", "staging.", "test." ,"uat.","demo."];
      const hostname = window.location.hostname.toLowerCase();
      return (
        window.location.protocol === "https:" ||
        allowed_domains.some((domain) => hostname.includes(domain)) ||
        hostname.endsWith(".local") ||
        hostname.endsWith(".test") ||
        hostname.endsWith(".dev")
      );
    },
    handle_camera_error(message) {
      console.error(message);
      this.camera_loading = false;
      this.camera_error = new Error(message);
      if (typeof this.show_error === "function") {
        this.show_error(message);
      }
    },
    setup_camera_stream(stream) {
      this.stream = stream;
      this.video_element.srcObject = stream;
      this.video_element.play();
      this.camera_loading = false;
      this.camera_error = null;
    },
    handle_camera_stream_error(error) {
      console.error("Error accessing camera:", error);
      this.camera_loading = false;
      this.camera_error = error;
      if (typeof this.show_error === "function") {
        const messages = {
          NotAllowedError: "Camera access denied. Allow permissions and refresh.",
          NotFoundError: "No camera found on device.",
          NotReadableError: "Camera is already in use.",
        };
        this.show_error(messages[error.name] || "Cannot access camera: " + error.message);
      }
    },
    request_camera_access() {
      if (navigator.mediaDevices?.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: { width: { ideal: 300 }, height: { ideal: 300 }, facingMode: "user" } })
          .then(this.setup_camera_stream)
          .catch(this.handle_camera_stream_error);
      } else {
        this.handle_camera_error("Your browser does not support camera access");
      }
    },
    init_camera() {
      this.setup_camera_elements();
      if (!this.validate_camera_elements()) {
        this.handle_camera_error("Camera elements not found");
        return;
      }
      if (!this.is_secure_context()) {
        this.handle_camera_error("Camera access requires HTTPS");
        return;
      }
      this.request_camera_access();
    },
    stop_camera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
      }
    },
    take_photo() {
      if (!this.video_element || !this.canvas_element) {
        this.show_error?.("Camera not ready. Please try again.");
        return;
      }
      const ctx = this.canvas_element.getContext("2d");
      this.canvas_element.width = this.video_element.videoWidth;
      this.canvas_element.height = this.video_element.videoHeight;
      ctx.drawImage(this.video_element, 0, 0, this.canvas_element.width, this.canvas_element.height);
      const canvas_data_url = this.canvas_element.toDataURL("image/png");

      // Convert base64 data URL to binary data
      const base64_data = atob(canvas_data_url.split(",")[1]);
      const mime_type = canvas_data_url.split(",")[0].split(":")[1].split(";")[0];

      // Create an ArrayBuffer to store the binary data
      const array_buffer = new ArrayBuffer(base64_data.length);
      const uint8_array = new Uint8Array(array_buffer);

      // Populate the Uint8Array with the binary data
      for (let index = 0; index < base64_data.length; index++) {
        Object.defineProperty(uint8_array, index, {
          value: base64_data.charCodeAt(index),
          writable: true,
          enumerable: true,
          configurable: true
        });
      }

      // Create a Blob from the binary data and MIME type
      const image_blob = new Blob([array_buffer], { type: mime_type });

      // Create a File object from the Blob
      const photo_file = new File([image_blob], "selfie.png", { type: mime_type });

      // Create a photo object to store the file and file name
      const photo_object = {
        file: photo_file,
        file_name: photo_file.name
      };

      // Set the source for the photo preview
      this.photo_src = canvas_data_url;
      this.photo_taken = true;

      // Emit the photo object to the parent component
      this.$emit("update:model_value", photo_object);

      // If the parent component has form data, set the value for the corresponding model
      if (this.$parent?.safe_form_data && this.question?.model) {
        Reflect.set(this.$parent.safe_form_data, this.question.model, photo_object);
      }

      this.stop_camera();
    },
    retake_photo() {
      const ctx = this.canvas_element?.getContext("2d");
      ctx?.clearRect(0, 0, this.canvas_element.width, this.canvas_element.height);
      this.photo_src = "";
      this.photo_taken = false;
      this.$emit("update:model_value", "");
      this.init_camera();
    },
    submit_photo() {

      if (!this.photo_src) {
        this.show_error?.("Please take a photo first");
        return;
      }
      this.show_success("Photo submitted successfully");
      this.stop_camera();
    },
    load_user_data() {
      this.user_profile_data = { id_number: "9001015000089", user_id: "12345" };
    },
    get_csrf_token() {
      const name = "csrftoken";
      let cookie_value = null;
      if (document.cookie) {
        const cookies = document.cookie.split(";");
        for (let cookie of cookies) {
          cookie = cookie.trim();
          if (cookie.startsWith(name + "=")) {
            cookie_value = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
      return cookie_value;
    },
  },
};